import { PANELMANAGER_SET_PANELPROPS_VALIDATIONERROR } from '../../constants';

export type SetPanelPropsValidationErrorAction = {
    type: typeof PANELMANAGER_SET_PANELPROPS_VALIDATIONERROR;
    panelPropsValidationError: any;
}

/**
 * @memberOf! Actions
 *
 * @param {Object} panelPropsValidationError
 *
 * @return {setPanelPropsValidationError}
 */
const setPanelPropsValidationError = ( panelPropsValidationError: any ): SetPanelPropsValidationErrorAction => {
    return {
        type: PANELMANAGER_SET_PANELPROPS_VALIDATIONERROR,
        panelPropsValidationError
    };
}

export default setPanelPropsValidationError;
